import React from "react"
import { usePrismicDocumentsByType } from "@prismicio/react"

import { BottomCategories } from "./BottomCategories"

export const BottomCategoriesFetch = ({ data }) => {
	const [documents, { state, error }] = usePrismicDocumentsByType("category")

	if (state !== "loaded") return null

	return <BottomCategories data={documents} topData={data} />
}
